import { useChartSeries } from '@/features/charts';
import useChartOptions from '@/features/charts/hooks/options/useChartOptions';
import useSpotOptions from '@/features/charts/hooks/options/useSpotOptions';
import type { TemplateChartSeries } from '@/shared/types/charts';

import AuthenticatedChart from './AuthenticatedChart';

const AuthenticatedSpotChart = ({
  templateChartSeries
}: {
  templateChartSeries: TemplateChartSeries[];
}) => {
  const { loading, error, chartSeries } = useChartSeries(templateChartSeries);
  const { createOptions } = useSpotOptions(14);
  const { options: chartOptions } = useChartOptions(chartSeries, createOptions);
  return (
    <AuthenticatedChart
      chartOptions={chartOptions}
      chartSeries={chartSeries}
      chartType='spot'
      error={error}
      loading={loading}
    />
  );
};

export default AuthenticatedSpotChart;
